import {SaveNodeDataContext} from '@/helpers/SaveNodeDataProvider/SaveNodeDataProvider'
import {useContext} from 'react'

export const useSaveNodeData = () => {
  return useContext(SaveNodeDataContext)
}
